import  { useEffect, useState } from 'react'
import './pii.css'

import PiiAuditlog from './auditlog/auditlog'
import PiiConfiguration from './configuration/pii-configuration'
import { RhyBusTabs } from '@rhybus/tabs'
export default function Pii () {
  const [activeTab, setActiveTab] = useState<number>(0)
  const [tableitems, settableitems] = useState<any>()

  useEffect(() => {
    document.title='PII'
    settableitems([
           {
        tabtitle: 'Configuration',
        icon: 'icon-rb-configuration',
        is_active: activeTab === 0,
        content: (<PiiConfiguration />)
      },
      {
        tabtitle: 'Audit Log',
        icon: 'icon-rb-auditlog',
        is_active: activeTab === 1,
        content: (<PiiAuditlog />)
      }
    ])
  }, [])
  return (
    <main id="main-content">
      <RhyBusTabs setActiveTab={(index: any) => { setActiveTab(index) }} items={tableitems} className="poppins-medium whitebg shadow-1 lg darktext " contentstyles='whitebg m-2  border-radius' pagetitleicon="icon-rb-users-three-fill color-primary pe-1" pagetitle="PII" pagetitleClass="poppins-semibold text-color-7 font-18 align-items-center" tabsul="px-3 align-items-center" anchorclass="darktext mb-0 font-13" tablistclassName="overflow-auto ms-auto" />
    </main>
  )
}
